<template>
  <section id="company_container" class="custom-container">
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <div class="columns v-align-center">
      <div class="column input-search-content mt-button2">
        <b-field class="input-search">
          <b-input
            placeholder="Buscar"
            type="text"
            name="search"
            v-model="search"
            icon-right="magnify"
            icon-right-clickable
            @icon-right-click="editModal = true"
          >
          </b-input>
        </b-field>
        <b-field class="pagination-select">
          <b-select
            placeholder="Páginas"
            expanded
            v-model="pagination"
            name="pagination"
          >
            <option
              v-for="option in paginationList"
              :value="option.id"
              :key="option.id"
              :id="option.id"
            >
              {{ option.label }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column text-right mt-button2">
        <vs-button
          color="primary"
          icon="add"
          class="btn-add-device"
          @click="createCompany"
          >Crear Empresa</vs-button
        >
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-table :data="tableData" max-items="5">
          <b-table-column field="code" label="Id" v-slot="props">
            <text-highlight :queries="search">
              {{ props.row.code }}
            </text-highlight>
          </b-table-column>
          <b-table-column
            field="identification"
            label="Identificación"
            v-slot="props"
          >
            <text-highlight :queries="search">
              {{ props.row.identification }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="status" label="Estado" v-slot="props">
            <text-highlight :queries="search">
              {{ parseStatus(props.row.status) }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="name" label="Nombre empresa" v-slot="props">
            <div class="flex name-options-table">
              <span class="label-title">
                <text-highlight :queries="search">
                  {{ props.row.name }}
                </text-highlight>
              </span>
              <div class="options flex">
                <button
                  class="btn primary edit"
                  v-on:click="editRow(props.row)"
                  title="Editar"
                >
                  <span class="material-icons"> edit </span>
                </button>
              </div>
            </div>
          </b-table-column>
          <template #empty>
            <div class="has-text-centered">Sin registros</div>
          </template>
        </b-table>
      </div>
    </div>
    <div class="columns">
      <div class="column" v-if="checkPages()">
        <vs-pagination
          :max="5"
          :total="totalPages"
          v-model="page"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import { DETAILS_STATUS } from "../../../global/constants";
import { ROUTES } from "../../../global/api_routes";
import { configToast, TOAST_TYPES } from "../../../global/toast";
export default {
  components: {},
  data: () => ({
    isLoading: false,
    selected: null,
    tableData: [],
    totalNumData: 0,
    originalData: [],
    search: "",
    page: 1,
    forRemove: null,
    pagination: 10,
    totalPages: 0,
    company: null,
    paginationList: [
      { id: 10, label: "10" },
      { id: 30, label: "30" },
      { id: 60, label: "60" },
      { id: 100, label: "100" },
      { id: 1000, label: "1000" },
    ],
  }),
  mounted() {
    this.getListCompanies();
  },
  watch: {
    search: function (value) {
      this.tableData = this.originalData.filter((item) => {
        const string = JSON.stringify(item) + this.parseStatus(item.status);
        return new RegExp(`${value}`, "igm").test(string);
      });
    },
    pagination: function () {
      this.splitData();
    },
    page: function () {
      this.splitData();
    },
    company: function () {
      this.getListCompanies(this.company);
    },
  },
  methods: {
    splitData() {
      if (!this.checkPages()) {
        this.tableData = this.originalData;
        return;
      }
      if (this.totalNumData <= this.pagination) {
        this.tableData = this.originalData;
        return;
      }
      this.totalPages = Math.ceil(this.totalNumData / this.pagination);
      const offset = Math.round((this.page - 1) * this.pagination);
      const limit = Math.round(this.pagination * this.page);
      this.tableData = this.originalData.slice(offset, limit);
    },
    checkPages() {
      return this.totalNumData > this.pagination;
    },
    parseStatus(status) {
      return DETAILS_STATUS[status]
        ? DETAILS_STATUS[status].description
        : "N/A";
    },
    updatedDevice(updatedGroup) {
      this.getListCompanies();
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#create_device_cotainer");
      return instance.open(message, type);
    },
    delete(device) {
      this.isLoading = true;
      this.$http
        .post(ROUTES.DASHBOARD.CONFIG_DEVICES.DELETE, {
          deviceId: device.code,
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.toast("Se ha eliminado el dispositivo", TOAST_TYPES.SUCCESS);
            return;
          }
          this.toast("No se pudo eliminar el dispositivo", TOAST_TYPES.ERROR);
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.getListCompanies();
        });
    },
    editRow(row) {
      this.$router.push(`/view/company/create?code=${row.code}`);
    },
    openModal() {
      this.$refs.refCreateDevice.openModal();
    },
    createCompany() {
      this.$router.push("/view/company/create");
    },
    getListCompanies() {
      this.isLoading = true;
      this.$http
        .get(ROUTES.DASHBOARD.GET_SAVED_COMPANIES, {
          params: { criteria: this.search },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.originalData = data.info;
            this.totalNumData = data.info.length;
            this.splitData();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
.sub-title {
  font-size: 1.6em;
  margin: 0;
  padding: 0;
}
.custom-container {
  margin-top: 20px;
}
.input-search {
  max-width: 300px;
}
.btn-add-device {
  margin-left: auto;
}
.text-right {
  display: flex;
  justify-content: flex-end;
}

.name-options-table {
  display: flex;
  width: 100%;
}
.name-options-table .options {
  margin-left: auto;
}
.name-options-table .options .btn {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background-color: #efefef;
  display: flex;
  padding: 0;
  outline: none;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  transition: all 1ms ease;
}
.name-options-table .options .btn span {
  font-size: 1.5em;
}
.name-options-table .options .btn:last-child {
  margin-right: 0;
}
.name-options-table .options .btn.primary {
  background-color: #1d76fb;
  color: #ffffff;
}
.name-options-table .options .btn:active {
  background-color: black;
  color: #ffffff;
}
.pagination-select {
  max-width: 120px;
}
.input-search-content {
  display: flex;
}
</style>
